// Package Imports
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";

const ActiveStateDisplayInput = ({ value }: { value: boolean }) => {
  return (
    <div
      className={`pulse-display-f pulse-align-center pulse-typography-body-1`}
    >
      {value ? (
        <CheckCircleIcon className="pulse-mr-1" sx={{ color: "#119436" }} />
      ) : (
        <ErrorIcon className="pulse-mr-1" sx={{ color: "#b40811" }} />
      )}

      {value ? (
        <p className="pulse-color--success-700">Active</p>
      ) : (
        <p className="pulse-color--error-700">Not Active</p>
      )}
    </div>
  );
};

export default ActiveStateDisplayInput;
